import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewEncapsulation,
  ViewChildren,
  QueryList
} from "@angular/core";
import { AgrAction } from "../../bean/agr-action";
import { AgrBlockItem } from "../../bean/agr-block-item";
import { AgrBlockListItemComponent } from '../agr-block-list-item/agr-block-list-item.component';

@Component({
  selector: "agr-block-list",
  templateUrl: "./agr-block-list.component.html",
  styleUrls: ["./agr-block-list.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class AgrBlockListComponent implements OnInit {
  @Input() blockItems: AgrBlockItem[];
  @Input() labelNoResults = "No results";
  @Input() previousLabel = "Previous";
  @Input() nextLabel = "Next";
  @Input() showHeader = true;
  @Input() showInfoAdditional = true;
  @Input() showActions = true;
  @Input() showBorder = true;
  @Input() pagination = 10;

  @Output() itemSelected: EventEmitter<any>;
  @Output() actionSelected: EventEmitter<AgrAction>;

  @ContentChild("templateHeader", { static: false }) templateHeader: TemplateRef<any>;
  @ContentChild("templateData", { static: false }) templateData: TemplateRef<any>;
  @ContentChild("templateInfoAdditional", { static: false }) templateInfoAdditional: TemplateRef<any>;

  @ViewChildren(AgrBlockListItemComponent) blocks: QueryList<AgrBlockListItemComponent>;

  public page: number;

  constructor() {
    this.page = 1;
    this.itemSelected = new EventEmitter<any>();
    this.actionSelected = new EventEmitter<AgrAction>();
  }

  ngOnInit() {
    if (this.pagination < 0) {
      this.pagination = 10;
    }
  }

  public sendAction($event): void {
    this.actionSelected.emit($event);
  }

  public selectItem(item: any): void {
    this.itemSelected.emit(item);
  }

  /**
   * MÃ©todo encargado de cerrar el menÃº de acciones. Se gestiona desde el padre
   * Cierra todos menos los del elemento seleccionado ya que podemos mostrar un menÃº de acciones
   * de un bloque, luego otro, etc y solo puede mostrarse uno desplegado
   *
   * @param id: id of agr-block-list-item received
   */
  public closeOptionsExcept(id: string): void {
    this.blocks.forEach(block => {
      if (block.id !== id) {
        block.showOptions = false;
      }
    });
  }
}
